export enum StorageKey {
  /**
   * 数据商品详情表
   */
  DATA_GOODS_DETAIL_TABLE = "DATA_GOODS_DETAIL_TABLE",
  /**
   * 数据流量来源表
   */
  DATA_FLOW_SOURCE_CARD_TABLE = "DATA_FLOW_SOURCE_CARD_TABLE",
  /**
   * 数据流量转化表
   */
  DATA_FLOW_CONVERT_CARD_TABLE = "DATA_FLOW_CONVERT_CARD_TABLE",
  /**
   * 履约明细表
   */
  DATA_PERFORMANCE_DETAIL_TABLE = "DATA_PERFORMANCE_DETAIL_TABLE",
  /**
   * 退换货数据明细表
   */
  AFTER_SALE_TABLE = "AFTER_SALE_TABLE",
  /**
   * 货期明细表
   */
  DELIVER_SCHEDULE_DETAIL_TABLE = "DELIVER_SCHEDULE_DETAIL_TABLE",
  /**
   * 开单表
   */
  ORDER_CREATE_TABLE = "ORDER_CREATE_TABLE",
  /**
   * 一条订单流开单表
   */
  ORDER_UNIFIED_CREATE_TABLE = "ORDER_UNIFIED_CREATE_TABLE",
  /**
   * 销售表
   */
  ORDER_SALES_TABLE = "ORDER_SALES_TABLE",
  /**
   * 一条订单流销售表
   */
  ORDER_UNIFIED_SALES_TABLE = "ORDER_UNIFIED_SALES_TABLE",
  /**
   * 订货单-常规订单表
   */
  ORDER_SHEET_COMMON_ORDER_TABLE = "ORDER_SHEET_COMMON_ORDER_TABLE",
  /**
   * 订货单-一条订单流表
   */
  ORDER_SHEET_UNIFIED_ORDER_TABLE = "ORDER_SHEET_UNIFIED_ORDER_TABLE",
  /**
   * 前置仓计划商品表
   */
  PRE_STORE_PLAN_CREATE_TABLE = "PRE_STORE_PLAN_CREATE_TABLE",
  /**
   * 前置仓邀约池商品表
   */
  PRE_STORE_INVITATION_TABLE = "PRE_STORE_INVITATION_TABLE",
  /**
   * 前置仓库存表
   */
  PRE_STORE_STOCK_TABLE = "PRE_STORE_STOCK_TABLE",
  /**
   * 前置仓库存入库日志表
   */
  PRE_STORE_STOCK_MOVEMENT_INBOUND_TABLE = "PRE_STORE_STOCK_MOVEMENT_INBOUND_TABLE",
  /**
   * 前置仓库存出库日志表
   */
  PRE_STORE_STOCK_MOVEMENT_OUTBOUND_TABLE = "PRE_STORE_STOCK_MOVEMENT_OUTBOUND_TABLE",
  /**
   * 前置仓报表详情表
   */
  PRE_STORE_REPORT_DETAIL_TABLE = "PRE_STORE_REPORT_DETAIL_TABLE",
  /**
   * 前置仓报表余额明细表
   */
  PRE_STORE_REPORT_BALANCE_DETAIL_TABLE = "PRE_STORE_REPORT_BALANCE_DETAIL_TABLE",
  /**
   * 前置仓报表计划明细表
   */
  PRE_STORE_REPORT_PLAN_DETAIL_TABLE = "PRE_STORE_REPORT_PLAN_DETAIL_TABLE",
  /**
   * 前置仓报表无数据明细表
   */
  PRE_STORE_REPORT_NODATA_DETAIL_TABLE = "PRE_STORE_REPORT_NODATA_DETAIL_TABLE",
  /**
   * 前置仓报表出库明细表
   */
  PRE_STORE_REPORT_STOCKOUT_DETAIL_TABLE = "PRE_STORE_REPORT_STOCKOUT_DETAIL_TABLE",
  /**
   * 前置仓报表退供明细表
   */
  PRE_STORE_REPORT_RETURN_DETAIL_TABLE = "PRE_STORE_REPORT_RETURN_DETAIL_TABLE",
  /**
   * 前置仓报表账单商品明细表
   */
  PRE_STORE_REPORT_BILL_GOODS_DETAIL_TABLE = "PRE_STORE_REPORT_BILL_GOODS_DETAIL_TABLE",
  /**
   * 前置仓报表活动抵扣明细表
   */
  PRE_STORE_REPORT_ACTIVITY_DEDUCTION_DETAIL_TABLE = "PRE_STORE_REPORT_ACTIVITY_DEDUCTION_DETAIL_TABLE",
  /**
   * 前置仓报表退供明细表
   */
  PRE_STORE_REPORT_RETURN_PROFIT_DETAIL_TABLE = "PRE_STORE_REPORT_RETURN_PROFIT_DETAIL_TABLE",
  /**
   * 前置仓报表商品抵扣明细表
   */
  PRE_STORE_REPORT_DED_GOODS_DETAIL_TABLE = "PRE_STORE_REPORT_DED_GOODS_DETAIL_TABLE",
  /**
   * 短信计划表
   */
  MESSAGE_PLAN_LIST_TABLE = "MESSAGE_PLAN_LIST_TABLE",
  /**
   * 短信发送记录表
   */
  MESSAGE_SEND_RECORD_TABLE = "MESSAGE_SEND_RECORD_TABLE",

  /** -------------------------------- **/

  /**
   * 弹窗key
   */
  MODAL_KEY = "MODAL_KEY",
  /**
   * 备货天数设置(按店铺存储)
   */
  STOCKING_DAY_SETTING = "STOCKING_DAY_SETTING",
}
